import { Injectable } from '@angular/core';
import { ActivatedRoute, CanActivate, CanLoad, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { CognitoUser, Auth } from '@aws-amplify/auth';
import { NgxIndexedDBService } from 'ngx-indexed-db';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanLoad, CanActivate {
  constructor(private _router: Router, private authService: AuthService,
    private dbService: NgxIndexedDBService) {}

  canLoad():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.authService.isAuth().pipe(
      tap((user: any) => {
        if (!user) {
          this._router.navigate(['/login']);
        }
      }),
      take(1)
    );
  }
  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return Auth.currentAuthenticatedUser()
      .then((result: CognitoUser) => {
        console.log('inicia');
        if (result.getSignInUserSession().isValid()) {
            console.log('inicia true');
            //trae la informacion del usuario
            //result.getSignInUserSession().getAccessToken().getJwtToken;
            //token para refresh
            //result.getSignInUserSession().getRefreshToken().getToken;
            //Identificador del usuario 
            //result.getSignInUserSession().getAccessToken().payload;
            this.dbService
            .add('user', {
              tipo: 'userLog',
              token: result.getSignInUserSession().getAccessToken().getJwtToken().toString(),
              refresh: result.getSignInUserSession().getRefreshToken().getToken().toString(),
              user: result.getSignInUserSession().getAccessToken().payload
            })
            .subscribe((key) => {
              console.log('key: ', key);
            });
          return true;
        } else {
            console.log('inicia false');
          this._router.navigate(['/login']);
          return false;
        }
      })
      .catch(() => {
        this._router.navigate(['/login']);
        console.log('error');
        return false;
      });
  }
}
